export const imgTypes = ['.gif', '.jpeg', '.jpg', '.png'];

export const openInBrowserFileTypes = ['gif', 'jpeg', 'jpg', 'pdf', 'png', 'txt'];

export const openInBrowserDocumentFileTypes = ['pdf', 'txt'];

export const getFileType = (url: string) => {
  if (url.includes('.pdf')) {
    return 'pdf';
  } else if (url.includes('.txt')) {
    return 'txt';
  } else if (imgTypes.some((imgType: string) => url.includes(imgType))) {
    return 'img';
  }
};
